import { useState } from "react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import api, { formatApiError } from "../lib/api";

export default function DeleteSettlementDialog({ loanId, settlement, onClose, onDone }) {
  const [removing, setRemoving] = useState(false);

  const removeSettlement = async () => {
    setRemoving(true);
    try {
      await api.delete(`/loans/${loanId}/settlement`);
      toast.success("Settlement removed and loan reopened");
      onDone();
      onClose();
    } catch (error) {
      toast.error(formatApiError(error));
    } finally {
      setRemoving(false);
    }
  };

  return (
    <Dialog open={Boolean(settlement)} onOpenChange={(open) => !open && onClose()}>
      <DialogContent data-testid="delete-settlement-dialog">
        <DialogHeader>
          <DialogTitle>Remove settlement?</DialogTitle>
          <DialogDescription>
            This reopens the loan, restores its next due date, and removes the settlement from the
            payment timeline and reports.
          </DialogDescription>
        </DialogHeader>
        <div className="dialog-actions">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            data-testid="cancel-delete-settlement-button"
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="destructive"
            disabled={removing}
            onClick={removeSettlement}
            data-testid="confirm-delete-settlement-button"
          >
            {removing ? "Removing…" : "Remove settlement"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}